export enum TimeUnit {
  month = 'MONTH',
  year = 'YEAR',
  quarter = 'QUARTER',
}
